// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3ODi9","tableCaixa":"styles_tableCaixa__3X57s"};